import '@babel/polyfill';
import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
